/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MapUserCustomizedSearchOptions } from '../../models/map-user-customized-search-options';

export interface GetMapCustomizedFilters$Params {
}

export function getMapCustomizedFilters(http: HttpClient, rootUrl: string, params?: GetMapCustomizedFilters$Params, context?: HttpContext): Observable<StrictHttpResponse<MapUserCustomizedSearchOptions>> {
  const rb = new RequestBuilder(rootUrl, getMapCustomizedFilters.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MapUserCustomizedSearchOptions>;
    })
  );
}

getMapCustomizedFilters.PATH = '/map/filters';
